8/**
 * Add and remove class from accordion for better styling
 */

const $ = jQuery;

const addAccordionClass = () => {

    const accordions = Array.from(document.getElementsByClassName('faq-wrapper'));

    if (accordions.length !== 0) {
        accordions.forEach(function (accordion) {
            accordion.addEventListener('show.bs.collapse', function (event) {
                const panel = event.target;
                panel.parentNode.classList.add('show');
            });
        } )
        accordions.forEach(function (accordion) {
            accordion.addEventListener('hide.bs.collapse', function (event) {
                const panel = event.target;
                panel.parentNode.classList.remove('show');
            });
        })
    }

    //Toggle accordion item when clicked wherever not only accordion button exactly
    $('.accordion-item').click(function() {
        // Get the current accordion item's collapse element
        const collapseElement = $(this).find('.accordion-collapse');
        // Toggle the collapse state
        collapseElement.collapse('toggle');
        const accordion = $(this).closest('.faq-wrapper');
        // Close other open accordion items
        accordion.find('.accordion-item').not(this).find('.accordion-collapse').collapse('hide');
    });
}

export { addAccordionClass };